module.exports = __webpack_public_path__ + "img/gear-icon.dbd0353d.svg";